import SharedLiveClassRoom from "@/components/feature/live-class/LiveClassRoom";

interface StudentLiveClassRoomProps {
  title: string;
  roomCode: string;
  studentName: string;
  hostIdentity: string;
  onExit: () => void;
}

export default function StudentLiveClassRoom({
  title,
  roomCode,
  studentName,
  hostIdentity,
  onExit,
}: StudentLiveClassRoomProps) {
  return (
    <SharedLiveClassRoom
      title={title}
      roomCode={roomCode}
      userName={studentName}
      isHost={false}
      hostIdentity={hostIdentity}
      onExit={onExit}
    />
  );
}